import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function DS_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <DS_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <DS_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function DS_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What programming languages should I learn for a career in data
              science?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              The most common programming languages for data science are Python
              and R. Python is favored for its simplicity and extensive
              libraries (like Pandas, NumPy, and scikit-learn), while R is great
              for statistical analysis and visualization. SQL is also crucial
              for data manipulation and querying databases.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What are the key skills needed for a data scientist?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Key skills include statistical analysis, machine learning, data
              visualization, data manipulation, and proficiency in programming
              languages (Python, R, SQL). Additionally, skills in data
              wrangling, cloud computing, and familiarity with tools like
              TensorFlow, Tableau, or Hadoop can be beneficial.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What is the typical career path for a data scientist?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              A typical career path starts with roles such as Data Analyst or
              Junior Data Scientist, progressing to roles like Data Scientist,
              Senior Data Scientist, and eventually to positions such as Data
              Science Manager or Chief Data Officer. Continuous learning and
              specialization in areas like machine learning or big data can
              enhance career advancement.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How important is domain knowledge in data science?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Domain knowledge is very important in data science. Understanding
              the industry in which you work allows you to make more informed
              decisions, ask better questions, and derive actionable insights
              from data. Different sectors (healthcare, finance, e-commerce) may
              require specific knowledge to apply data science effectively.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What projects or experience should I have on my resume?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Having a portfolio of projects that showcase your data science
              skills is crucial. This can include personal projects,
              internships, or contributions to open-source projects. Focus on
              projects that demonstrate your ability to analyze data, build
              predictive models, and visualize results. Highlight any real-world
              applications of your work, especially those that had a significant
              impact.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}
export default DS_FAQ_page
